import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '@core/services/auth/auth.service';
import { environment } from '@env/environment';

@Injectable()
export class ApiHeaderInterceptor implements HttpInterceptor {
  private readonly NPI_API_URL = environment.npiApiUrl;

  constructor(private readonly authService: AuthService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url.startsWith(this.NPI_API_URL)) {
      const modifiedRequest = request.clone({
        setHeaders: {
          'X-API-Key': environment.npiApiKey,
          'X-API-Token': environment.npiApiToken,
        },
      });
      return next.handle(modifiedRequest);
    }

    const token = this.authService.getToken();

    if (token) {
      const modifiedRequest = request.clone({
        setHeaders: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      return next.handle(modifiedRequest);
    }
    return next.handle(request);
  }
}
